/**
 * Full-page loader used exclusively during portal_validating state.
 * Full screen, no header or navigation.
 * Rendered inside a container that remains visible during theme-transitioning (hide-then-reveal).
 * Uses LoadingSpinner so bounce timing/size/tokens stay in one place.
 */
import React from 'react';
import { LoadingSpinner } from '../Loading/LoadingSpinner';

/** Same copy for portal validation and clinic-staff approval gate loading UI. */
export const VERIFYING_ACCESS_MESSAGE = 'Verifying your access…';

export const FullPageLoader: React.FC = () => {
  return (
    <div className="full-page-loader-container fixed inset-0 z-full-page-loader flex min-h-screen w-full flex-col bg-surface">
      <LoadingSpinner
        layout="page"
        message={VERIFYING_ACCESS_MESSAGE}
        ariaLabel={VERIFYING_ACCESS_MESSAGE}
        ariaLive="polite"
      />
    </div>
  );
};
